import { ApiResponse } from '@packages/global';
import { httpClient } from '../httpClient';

export const novelUploadApi = {
  /**
   * 上传小说文件（TXT/MD/DOCX，≤50MB）
   */
  async uploadNovel(formData: FormData): Promise<{ url: string }> {
    const response = await httpClient.instance.post<ApiResponse<{ url: string }>>('/user/upload/novel', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });

    if (!response.data.success || !response.data.data) {
      throw new Error(response.data.message || '小说文件上传失败');
    }

    return response.data.data;
  }
};
